// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { fadeInOut } from '../../services/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Offer, PhotoDetail, OfferDetail, OfferVM, OfferDetailVM } from 'src/app/models/offer.model';
import * as FileSaver from 'file-saver';
import { OfferVm } from 'src/app/models/offerVm.model';
import { Product } from 'src/app/models/Product.model';
import { Poze } from 'src/app/models/Poze.model';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AppTranslationService } from 'src/app/services/app-translation.service';
import { SelectionModel } from '@angular/cdk/collections';
import { EditDialogComponent } from '../editDialogComponent/editDialogComponent.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
  animations: [fadeInOut]
})

export class OfferComponent {
  private isSaving: boolean;
  private isNew: boolean;
  offerForm: FormGroup;
  offer: Offer;
  definireOffer: boolean = false;

  compensareDetaliata: Offer;

  id: string = '';
  subject: string = '';
  displayedColumns = ['id', 'date', 'car', 'user', 'companie', 'subject','clientName', 'modelAccess', 'actions'];
  displayedColumnsProduct = ['vehicleReference', 'productgrup', 'productnumber', 'description', 'descriptionfr', 'descriptionen', 'descriptionro', 'PriceDealer', 'PriceFinalCustomer'];
  displayedColumnsProducts = ['select', 'vehicleReference', 'productgrup', 'productnumber', 'description', 'descriptionfr', 'descriptionen', 'descriptionro', 'PriceDealer', 'PriceFinalCustomer'];
  editareOferta: boolean = false;
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  _currentUserId: string;
  data: OfferVm[];
  dataSource: MatTableDataSource<OfferVm>;
  dataPoze: Poze[];
  dataProducts: Product[];
  dataSelectedProducts: Product[];
  dataSourceProducts: MatTableDataSource<Product>;
  dataSourcePoze: MatTableDataSource<Poze>;
  dataSourceSelectedProducts: MatTableDataSource<Product>;
  selection = new SelectionModel<Product>(true, []);
  dataSourceProductsCarReference: Product[];
  dataSelectedDependentProducts: Product[];
  dataSourceProductsDependent: MatTableDataSource<Product>;
  listDependentProduct: boolean = false;

  carReference: string;
  tip_export: string = 'DOC';
  browserLang: string = "en";
  showEN: boolean = false;
  showNI: boolean = true;
  showRO: boolean = true;
  showFR: boolean = true;

  initialDate: Date = new Date();
  finalDate: Date = new Date();

  dataOfferDetails: OfferDetail[];
  dataOfferDetailsSource: MatTableDataSource<OfferDetail>;
  dataOfferPhotosSource: MatTableDataSource<PhotoDetail>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  addMonths = (date: Date, months: number): Date => {
    let result = new Date(date);
    result.setDate(result.getMonth() + months);
    return result;
  };

  afiseazaDate() {
    this.loadingIndicator = true;

    let id = this.id == null || this.id == "" ? "undefined" : this.id;
    let subject = this.subject == null || this.subject == "" ? "undefined" : this.subject;
    let initialDate = this.initialDate == null ? "undefined" : this.formatOnlyDate(this.initialDate, ".");
    let finalDate = this.finalDate == null ? "undefined" : this.formatOnlyDate(this.finalDate, ".");

    this.accountService
      .getOfferList(id, subject, initialDate, finalDate)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;

        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
        error => {
        });
  }
  
  ngAfterContentInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  reset() {
    this.id = '';
    this.subject = '';
    this.initialDate = new Date();
    this.initialDate.setMonth(this.initialDate.getMonth() - 3);
    this.finalDate = new Date();
    this.afiseazaDate();
  }

  modificare(offer: Offer) {
    this.definireOffer = true;
    this.offer = offer;

    this.accountService
      .getOfferListProductPhoto(offer.id)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        let dataOffer = liniiReconverted[0];

        if (dataOffer != null) {
          this.offer = dataOffer;
          this.dataOfferDetails = dataOffer.offerDetails;
          this.dataOfferDetailsSource.data = dataOffer.offerDetails;
          this.dataOfferPhotosSource.data = dataOffer.offerPhotos;
        }

        this.isDataLoaded = true;
      },
        error => {
        });
  }

  verificareStergere(offer: Offer) {
    this.alertService.showDialog('Delete', 'Do you confirm the deletion?', DialogType.confirm, () => this.stergeOffer(offer));
  }

  stergeOffer(offer: Offer) {
    let newOffer = new OfferVM();
    newOffer.id = offer.id;
    newOffer.status = "D";
    
    this.accountService.saveOffer(newOffer).subscribe(
      role => {
        this.saveSuccessHelper(this.offer, `Offer deleted!`);
        this.afiseazaDate();
      },
      error => this.saveFailedHelper(error));
  }

  adaugare() {
    this.definireOffer = true;
    this.offer = new Offer();
  }

  constructor(
    private translate: TranslateService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private translationService: AppTranslationService,
    private accountService: AccountService,
    public dialog: MatDialog
  ) {
    this.dataSource = new MatTableDataSource<OfferVm>();
    this.dataOfferDetailsSource = new MatTableDataSource<OfferDetail>();
    this.dataOfferPhotosSource = new MatTableDataSource<PhotoDetail>();
    this.dataSourceProducts = new MatTableDataSource<Product>();
    this.dataSourceSelectedProducts = new MatTableDataSource<Product>();
    this.dataSourceProductsDependent = new MatTableDataSource<Product>();
    this.dataSourcePoze = new MatTableDataSource<Poze>();
    this.buildForm();
  }

  selectionLanguage() {
    if (this.browserLang == "fr") {
      this.showFR = false;
      this.showEN = true;
      this.showNI = true;
      this.showRO = true;
    }
    if (this.browserLang == "en") {
      this.showFR = true;
      this.showEN = false;
      this.showNI = true;
      this.showRO = true;
    }
    if (this.browserLang == "ar") {
      this.showFR = true;
      this.showEN = true;
      this.showNI = true;
      this.showRO = false;
    }
    if (this.browserLang == "de") {
      this.showFR = true;
      this.showEN = true;
      this.showNI = false;
      this.showRO = true;
    }
  }

  ngOnInit() {
    this.offer = new Offer();
    this.initialDate.setMonth(this.initialDate.getMonth() - 3);
    this.afiseazaDate();
    var selectedLanguage = window.selectedLanguage;
    if (selectedLanguage == null || selectedLanguage == undefined) {
      selectedLanguage = 'en';
    }
    this.translationService.changeLanguage(selectedLanguage);

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang != null && event.lang != "undefined") {
        selectedLanguage = event.lang;
        window.selectedLanguage = selectedLanguage;
      }
      else if (event.lang == null || event.lang == "undefined") {
        this.browserLang = selectedLanguage;
      }
      this.browserLang = selectedLanguage;
      this.selectionLanguage();
    });
    this.browserLang = selectedLanguage;
    this.selectionLanguage();
   }
  
  save(offer: OfferVM) {
    this.offer.offerDetails = [];
    for (let product of this.dataSelectedProducts.filter(f => f.selected === true)) {
      let offerDetail = new OfferDetailVM;
      offerDetail.productId = product.id;
      offer.offerDetails.push(offerDetail);
    }

    if (this.offerForm.valid) {
      this.accountService.saveOffer(offer).subscribe(
        role => this.saveSuccessHelper(this.offer, `Vehicle saved successfully!`),
        error => this.saveFailedHelper(error));
    }
    this.cancel();
  }

  private saveSuccessHelper(offer?: Offer, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);

    this.definireOffer = false;
    this.afiseazaDate();
  }
  private saveSuccessHelperGenerateOffer(mesaj?: string) {
    this.alertService.stopLoadingMessage();
    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  public generareoffer(offer: Offer) {
    this.alertService.startLoadingMessage('Offer generation...');
    this.accountService.downloadOffer(this.tip_export, offer.id.toString(), this.browserLang).subscribe(result => {
      let blob = new Blob(result, {
        type: 'application/pdf' // must match the Accept type
      });
      if (this.tip_export === 'PDF') {
        let filename = 'Offer_' + offer.id + '.pdf';
        FileSaver.saveAs(blob, filename);
      }
      else if (this.tip_export === 'XLSX') {
        let filename = 'Offer_' + offer.id + '.xlsx';
        FileSaver.saveAs(blob, filename);
      }
      else if (this.tip_export === 'DOC') {
        let filename = 'Offer_' + offer.id + '.docx';
        FileSaver.saveAs(blob, filename);
      }
      this.saveSuccessHelperGenerateOffer(`The offer has been generated!`);
    });
  }
  
  private buildForm() {
    this.offerForm = this.formBuilder.group({
      tbModelAccess: ['', [Validators.required],],
      tbCar: ['', [Validators.required],],
      tbUser: ['', [Validators.required],],
      tbCompanie: ['', [Validators.required],],
      tbSubject: ['', [Validators.required],], 
      tbClientName: ['', [Validators.required],],
    });
  }

  get tbModelAccess() {
    return this.offerForm.get('tbModelAccess');
  }

  get tbCar() {
    return this.offerForm.get('tbCar');
  }

  get tbUser() {
    return this.offerForm.get('tbUser');
  }

  get tbCompanie() {
    return this.offerForm.get('tbModelAccess');
  }

  get tbSubject() {
    return this.offerForm.get('tbSubject');
  }

  get tbClientName() {
    return this.offerForm.get('tbClientName');
  }

  private cancel() {
    this.definireOffer = false;
    this.editareOferta = false;
    this.afiseazaDate();
  }

  GetPhotoUrl(poza: Poze): string {
    return '/' + poza.vehicleReference + "_" + poza.photoReference + "_" + poza.id + ".jpg";
  }

  editOffer(offer: OfferVm) {
    this.editareOferta = true;
    this.carReference = offer.car.modelAccess;
    this.dataSelectedProducts = [];
    this.dataSelectedDependentProducts = [];
    this.onProductgrupSelected("undefined", offer.car.make);
  }

  onProductgrupSelected(productgrupSelectat: string, marca: string) {
    this.accountService
      .getProductLists("undefined", "undefined", this.carReference, "undefined", "undefined", "undefined", productgrupSelectat, "undefined", "undefined", "undefined", "undefined", "undefined", "undefined", marca)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.dataProducts = liniiReconverted;

        if (productgrupSelectat === "undefined") {
          this.dataSourceProductsCarReference = this.dataProducts;
          for (let product of this.dataProducts) {
            for (let selectedProduct of this.offer.offerDetails) {
              if (product.id == selectedProduct.product.id) {
                product.selected = true;
                this.dataSelectedProducts.push(product);
              }
            }
          }
        }

        for (let product of this.dataProducts) {
          for (let selectedProduct of this.dataSelectedProducts) {
            if (product.id == selectedProduct.id) {
              product.selected = true;
            }
          }
          for (let selectedProduct of this.dataSelectedDependentProducts) {
            if (product.id == selectedProduct.id) {
              product.selectedDependentProduct = true;
            }
          }
        }

        this.dataSourceProducts.data = this.dataProducts;
        this.dataSourceSelectedProducts.data = this.dataProducts;

        this.definireOffer = false;
        this.definireOffer = true;
      },
        error => {
          this.definireOffer = true;
          this.definireOffer = false;
        });
  }

  getDependentProductsList() {
    for (let product of this.dataProducts) {
      for (let selectedProduct of this.dataSelectedDependentProducts) {
        if (product.id == selectedProduct.id) {
          this.listDependentProduct = false;
          product.selectedDependentProduct = false;
          product.selected = false;
        }
      }
    }

    this.dataSelectedDependentProducts.forEach((product) => {
      this.dataSelectedProducts = this.dataSelectedProducts.filter(f => f.id != product.id);
    });

    this.dataSelectedDependentProducts = [];

    this.dataSelectedProducts.forEach((product) => {
      if (product.depedentProduct !== null) {
        let idProducts = product.depedentProduct.split('#');

        for (var i = 0; i <= idProducts.length; i++) {
          let productInList = this.dataSourceProductsCarReference.find(f => f.id == idProducts[i]);
          if (productInList != null) {
            this.dataSelectedProducts.push(productInList);
            this.dataSelectedDependentProducts.push(productInList);
            productInList.selected = true;
          }
        }

        for (let product of this.dataProducts) {
          for (let selectedProduct of this.dataSelectedProducts) {
            if (product.id == selectedProduct.id) {
              product.selected = true;
            }
          }

          for (let selectedProduct of this.dataSelectedDependentProducts) {
            if (product.id == selectedProduct.id) {
              this.listDependentProduct = true;
              product.selectedDependentProduct = true;
            }
          }
        }
      }
    });
    this.dataSelectedDependentProducts = this.dataSelectedDependentProducts.filter((item, i, ar) => ar.indexOf(item) === i);
    this.dataSelectedProducts = this.dataSelectedProducts.filter((item, i, ar) => ar.indexOf(item) === i);
    this.dataSourceProductsDependent.data = this.dataSelectedDependentProducts;
  }

  MarkSelectionOfProduct(product: Product) {
    let currentProductInList = this.dataSelectedProducts.find(f => f.id === product.id);
    if (product.selected) {
      if (currentProductInList == null) {
        this.dataSelectedProducts.push(product);
      }
    }
    else {
      if (currentProductInList !== null) {
        this.dataSelectedProducts = this.dataSelectedProducts.filter(obj => obj !== currentProductInList);
      }
    }
    this.getDependentProductsList();
  }

  formatOnlyDate(value: Date, separator: string): string {
    var date = new Date(value);
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();

    return [
      (dd > 9 ? '' : '0') + dd,
      (mm > 9 ? '' : '0') + mm,
      date.getFullYear()
    ].join(separator);
  }

  clonareOferta(offer: OfferVM) {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      disableClose: true,
      width: '500px',
      data: { offer: offer }
    });

    dialogRef.componentInstance.saveFromParent.subscribe(result => {
      if (result === true) {
        this.reset();
      }
    });
  }

}
